import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";
import router from "@/router";

Vue.use(Vuex, Axios);

export default new Vuex.Store({
  state: {
    user: {},
    token_code: null,
    baseUrl: "https://lm8vvk39w6.execute-api.ap-south-1.amazonaws.com/api",
    // baseUrl:"http://127.0.0.1:8000",
    // verifyHeaders: {},
    members: [],
    role: "",
    attendeeCount: 0,
    streamCount: 0,
    isStage: false,
    isLive: false,
    isNetworking: true,
    isBreak: false,
    isExpire: false,
    isEnd: false,
    tables: [],
    isChatConnect: false,
    channelMembers: [],
    isSpeaker: false,
    showPermission: true,
    isScreenShare: false,
    isExternalVideoShared: false,
    networkStatus: "",
    isTableScreenShare: false,
    isHostHidden: false,
    hiddenUid: "",
    showScreenShareButtonForOthers: false,
    isSessionTimerDisabled: false,
    resourceId: "",
    sid: "",
    recordingUid: "",
    recordingToken: "",
    VENDOR: 1,
    customer_id: process.env.VUE_APP_CUSTOMER_ID,
    customer_certificate: process.env.VUE_APP_CUSTOMER_SECRET,
    ACCESS_KEY: process.env.VUE_APP_ACCESS_KEY,
    BUCKET: "meetbeans-data",
    REGION: 14,
    SECRET_KEY: process.env.VUE_APP_SECRET_KEY,
    baseRecordingUrl: "https://api.agora.io",
    streamKey: "",
    youtubeStreamKey: "",
    isFacebookLive: false,
    isYoutubeLive: false,
    recError: "",
    errorMessage: "",
    hasPermission: true,
    isActiveBackstageScreenShare: false,
    microphoneId: "",
    cameraId: "",
    auditoriumAudio: "https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/jazz-autitorium.m4a",
    newMessagesCount: 0,
    newQnaCount: 0,
    isCurrentWindow: true,
    startEventSidebar: false,
    result: [],
    layout: [[{"x_axis": 0.0,"y_axis": 0.0,"width": 1.0,"height": 1.0,"alpha": 1.0,"render_mode": 1}],
      [{"x_axis": 0.0,"y_axis": 0.0,"width": 0.5,"height": 1.0,"alpha": 1.0,"render_mode": 1},{"x_axis": 0.5,"y_axis": 0.0,"width": 0.5,"height": 1.0,"alpha": 1.0,"render_mode": 1}],
      [{"x_axis": 0.0,"y_axis": 0.0,"width": 0.6,"height": 1.0,"alpha": 1.0,"render_mode": 1},{"x_axis": 0.5,"y_axis": 0.1,"width": 0.5,"height": 0.45,"alpha": 1.0,"render_mode": 1},{"x_axis": 0.5,"y_axis": 0.5,"width": 0.5,"height": 0.45,"alpha": 1.0,"render_mode": 1}]]
      
  },
  mutations: {
    auth_error(state) {
      state.status = "error";
    },
    video_call(state) {
      state.isLive = true;
    },
    rec_error(state) {
      state.recError = "error";
    },
    updateStreamKey (state, streamKey) {
      state.streamKey = streamKey
    },
    updateYoutubeStreamKey (state, youtubeStreamKey) {
      state.youtubeStreamKey = youtubeStreamKey
    },
    updateLayout(state) {
      let result = [];
      let length = state.streamCount;
      let width = 1.0;
      let height = 1.0;
      let x = 0.0;
      let y = 0.0;
      if(length === 7) {
        result.push({"x_axis": 0.0, "y_axis": 0.0, "width": 0.25, "height": 1.0, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.25, "y_axis": 0.0, "width": 0.25, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.50, "y_axis": 0.0, "width": 0.25, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.75, "y_axis": 0.0, "width": 0.25, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.25, "y_axis": 0.5, "width": 0.25, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.50, "y_axis": 0.5, "width": 0.25, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.75, "y_axis": 0.5, "width": 0.25, "height": 0.5, "alpha": 1.0, "render_mode": 1})
      } else if(length === 6) {
        result.push({"x_axis": 0.0, "y_axis": 0.0, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.33, "y_axis": 0.0, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.66, "y_axis": 0.0, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.00, "y_axis": 0.5, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.33, "y_axis": 0.5, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.66, "y_axis": 0.5, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1})
      } else if(length === 5){
        result.push({"x_axis": 0.0, "y_axis": 0.0, "width": 0.33, "height": 1.0, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.33, "y_axis": 0.0, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.66, "y_axis": 0.0, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.33, "y_axis": 0.5, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1},
        {"x_axis": 0.66, "y_axis": 0.5, "width": 0.33, "height": 0.5, "alpha": 1.0, "render_mode": 1})
      } else if (length === 4) {
        for(let index=0;index<length;index++) {
          width = 1.0;
          height = 1.0;
          x = 0.0;
          y = 0.0;
          if(index%2 == 0){
            width =0.5;
            height = 0.5;
            x = 0.0;
            y = 0.0;
            if(index == 2) {
              y = 0.5; 
            }
          } else {
            x = 0.5;
            y = 0.0;
            if(index == 3){
              y = 0.5;
            }
          }
          result.push({"x_axis": x, "y_axis": y, "width": width, "height": height, "alpha": 1.0, "render_mode": 1})
        }
      } else if (length === 3) {
        result.push({"x_axis": 0.0,"y_axis": 0.0,"width": 0.6,"height": 1.0,"alpha": 1.0,"render_mode": 1},{"x_axis": 0.5,"y_axis": 0.1,"width": 0.5,"height": 0.45,"alpha": 1.0,"render_mode": 1},{"x_axis": 0.5,"y_axis": 0.5,"width": 0.5,"height": 0.45,"alpha": 1.0,"render_mode": 1})
      } else if (length === 2) {
        result.push({"x_axis": 0.0,"y_axis": 0.0,"width": 0.5,"height": 1.0,"alpha": 1.0,"render_mode": 1},{"x_axis": 0.5,"y_axis": 0.0,"width": 0.5,"height": 1.0,"alpha": 1.0,"render_mode": 1})
      } else if (length === 1) { 
        result.push({"x_axis": 0.0,"y_axis": 0.0,"width": 1.0,"height": 1.0,"alpha": 1.0,"render_mode": 1})
      }
      state.result = result;
    }
  },
  actions: {
    registerUser: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {
          "Content-Type": "application/json"
        };
        Axios({
          url: this.state.baseUrl + "/user/register",
          data: data,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              localStorage.setItem("user_verify", JSON.stringify(resp.data.data));
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    resetPassword: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {
          "Content-Type": "application/json"
        };
        Axios({
          url: this.state.baseUrl + "/user/forget",
          data: data,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              localStorage.setItem("user_verify", JSON.stringify(resp.data.data));
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    verifyUser: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let user = JSON.parse(localStorage.getItem("user_verify"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: user.id,
          token: user.token,
        };
        Axios({
          url: this.state.baseUrl + "/user/verify",
          data: data,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              localStorage.removeItem("user_verify");
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    userLogin: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {
          "Content-Type": "application/json",
        };
        Axios({
          url: this.state.baseUrl + "/user/login",
          data: data,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              localStorage.removeItem("user_verify");
              localStorage.setItem("user_info", JSON.stringify(resp.data.data));
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getUserCounter: function ({commit}) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/user/counters",
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$toast.open({
              message: "Something is wrong",
              type: "error",
              position: "top",
              queue: true
            });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getTutorials: function ({commit}) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/tutorials",
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$toast.open({
              message: "Something is wrong",
              type: "error",
              position: "top",
              queue: true
            });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getPastEvents: function ({commit}) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/events/past",
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$toast.open({
              message: "Something is wrong",
              type: "error",
              position: "top",
              queue: true
            });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getUpcomingEvent: function ({commit}) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/events/upcoming",
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$toast.open({
              message: "Something is wrong",
              type: "error",
              position: "top",
              queue: true
            });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getQuickEvent: function ({commit}) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/events/quick",
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$toast.open({
              message: "Something is wrong",
              type: "error",
              position: "top",
              queue: true
            });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getMeetID: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url: this.state.baseUrl + "/video-call",
          data: data,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getAgoraToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url: this.state.baseUrl + "/video-call/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventAgoraToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url: this.state.baseUrl + "/events/session/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getAgoraBackstageToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url: this.state.baseUrl + "/video-call/backstage/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventAgoraBackstageToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url: this.state.baseUrl + "/events/backstage/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getAgoraTableToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl +
            "/table/token/" +
            data.channel_id +
            "/" +
            data.table_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventAgoraTableToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl +
            "/events/table/token/" +
            data.channel_id +
            "/" +
            data.table_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getScreenShareTableToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl +
            "/video-call/table/screenshare/" +
            data.channel_id +
            "/" +
            data.table_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              console.log("success vs --", resp.data);
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventScreenShareTableToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl +
            "/events/table/screenshare/" +
            data.channel_id +
            "/" +
            data.table_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              console.log("success vs --", resp.data);
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getScreenShareBackstageToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl +
            "/video-call/backstage/screenshare/" +
            data.channel_id ,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              console.log("success vs --", resp.data);
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventScreenShareBackstageToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl +
            "/events/backstage/screenshare/" +
            data.channel_id ,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              console.log("success vs --", resp.data);
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getRecordingToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl +
            "/video-call/recording/" +
            data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp.data);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventRecordingToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl +
            "/events/recording/" +
            data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp.data);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventSid: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        console.log('sid data: ', data)
        Axios({
          url:
            this.state.baseUrl +
            "/events/recording/store/sid/" + data.session_id,
            data: {"s_id": data.sid},
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              // this.$store.state.sid = resp.data.sid;
              console.log('successfully stored sid')
              resolve(resp.data);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },
    storeSid: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        console.log('sid data: ', data)
        Axios({
          url:
            this.state.baseUrl +
            "/video-call/recording/store/sid/" + data.channel_id,
            data: {"s_id": data.sid},
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              // this.$store.state.sid = resp.data.sid;
              console.log('successfully stored sid')
              resolve(resp.data);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },
    storeEventStreamKey: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        console.log(data);
        Axios({
          url:
            this.state.baseUrl +
            "/events/livekey/store/" + data.session_id,
            data: {"facebook_key": data.facebook_key, "youtube_key": data.youtube_key},
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              // this.$store.state.sid = resp.data.sid;
              console.log('successfully stored stream keys')
              resolve(resp.data);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },
    storeStreamKey: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };

        Axios({
          url:
            this.state.baseUrl +
            "/video-call/livekey/store/" + data.channel_id,
            data: {"facebook_key": data.facebook_key, "youtube_key": data.youtube_key},
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              // this.$store.state.sid = resp.data.sid;
              console.log('successfully stored stream keys')
              resolve(resp.data);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getAgoraRTMToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {
          "Content-Type": "application/json",
          uid: data.uid,
        };
        Axios({
          url: this.state.baseUrl + "/chat/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventAgoraRTMToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {
          "Content-Type": "application/json",
          uid: data.uid,
        };
        Axios({
          url: this.state.baseUrl + "/events/chat/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getStreamKey: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url: this.state.baseUrl + "/video-call/livekey/get/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventStreamKey: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url: this.state.baseUrl + "/events/livekey/get/" + data.session_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getShareVideoToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl + "/video-call/screenvideo/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventShareVideoToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl + "/events/screenvideo/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getScreenShareToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl + "/video-call/screenshare/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventScreenShareToken: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        this.user = JSON.parse(localStorage.getItem("user_info"));
        let verifyHeaders = {
          "Content-Type": "application/json",
          id: this.user.id,
          token: this.user.token,
        };
        Axios({
          url:
            this.state.baseUrl + "/events/screenshare/" + data.channel_id,
          headers: verifyHeaders,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    insertUser: function ({commit}, user) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {"Content-Type": "application/json"};
        Axios({
          url: this.state.baseUrl + "/user",
          data: user,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getUserInfo: function ({commit}) {
      let headers = {
        "Content-Type": "application/json",
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/user",
          headers: headers,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              localStorage.setItem("user_info", JSON.stringify(resp.data.data));
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    deleteAccount: function ({commit}) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        let data = {}
        Axios({
          url: this.state.baseUrl + "/user/delete",
          headers: headers,
          data: data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    updateUser: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/user/update",
          headers: headers,
          data: data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              console.log(resp.data.data)
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getTeam: function ({commit}, communityId) {
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/user/team/" + communityId,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getAttendees: function ({commit}, communityId) {
      let headers = {
        "Content-Type": "application/json",
        id: JSON.parse(localStorage.getItem("user_info")).id,
        token: JSON.parse(localStorage.getItem("user_info")).token,
      };
      return new Promise((resolve, reject) => {
        Axios({
          url:
            this.state.baseUrl +
            "/organization/attendees/" + communityId,
          method: "GET",
          headers: headers
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEvents: function ({commit}, communityId) {
      let headers = {
        "Content-Type": "application/json",
        id: JSON.parse(localStorage.getItem("user_info")).id,
        token: JSON.parse(localStorage.getItem("user_info")).token,
      };
      return new Promise((resolve, reject) => {
        Axios({
          url:
            this.state.baseUrl +
            "/events/get/" + communityId,
          method: "GET",
          headers: headers
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    addEvent: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: JSON.parse(localStorage.getItem("user_info")).id,
          token: JSON.parse(localStorage.getItem("user_info")).token,
        };
        Axios({
          url: this.state.baseUrl + "/events/post",
          method: "POST",
          data: data,
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            {
              this.$toast.open({
                message: error,
                type: "success",
                position: "top",
                queue: true
              });
            }
            reject(error);
          });
      });
    },

    getEventDetail: function ({commit}, data) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url:
            this.state.baseUrl +
            "/dashboard/events/" +
            data.event_id,
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            // router.push("/dashboard");
            // this.$toast.open({
            //   message: "Something is wrong",
            //   type: "error",
            //   position: "top",
            // });
            commit("auth_error", error);
            reject(error);
          });
      });
    },
    getEventAttendees: function ({commit}, communityId) {
      let headers = {
        "Content-Type": "application/json",
        id: JSON.parse(localStorage.getItem("user_info")).id,
        token: JSON.parse(localStorage.getItem("user_info")).token,
      };
      return new Promise((resolve, reject) => {
        Axios({
          url:
            this.state.baseUrl +
            "/events/" + communityId + "/users",
          method: "GET",
          headers: headers
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },
    getEventRecordings: function ({commit}, event) {
      let headers = {
        "Content-Type": "application/json",
        id: JSON.parse(localStorage.getItem("user_info")).id,
        token: JSON.parse(localStorage.getItem("user_info")).token,
      };
      return new Promise((resolve, reject) => {
        Axios({
          url:
            this.state.baseUrl +
            "/recording/" + event,
          method: "GET",
          headers: headers
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },
    getRecordings: function ({commit}, data) {
      let headers = {
        "Content-Type": "application/json",
        id: JSON.parse(localStorage.getItem("user_info")).id,
        token: JSON.parse(localStorage.getItem("user_info")).token,
      };
      return new Promise((resolve, reject) => {
        Axios({
          url:
            this.state.baseUrl +
            "/video-call/recording/get/" + data.channel_id,
          method: "GET",
          headers: headers
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },
    getEditEventData: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/edit/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    updateEvent: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: JSON.parse(localStorage.getItem("user_info")).id,
          token: JSON.parse(localStorage.getItem("user_info")).token,
        };
        console.log(data)
        Axios({
          url: this.state.baseUrl + "/events/update/" + data.event_id,
          method: "POST",
          data: data,
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            {
              this.$toast.open({
                message: error,
                type: "success",
                position: "top",
                queue: true
              });
            }
            reject(error);
          });
      });
    },

    getEventSessionDetail: function ({commit}, data) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url:
            this.state.baseUrl +
            "/events/" +
            data.event_id + '/session/' + data.session_id,
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            // router.push("/dashboard");
            // this.$toast.open({
            //   message: "Something is wrong",
            //   type: "error",
            //   position: "top",
            // });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventDetailOutside: function ({commit}, data) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/events/" + data.event_id,
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            router.push("/");
            this.$toast.open({
              message: "Something is wrong",
              type: "error",
              position: "top",
              queue: true
            });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    goLive: function ({commit}, data) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/dashboard/events/live/" + data.event_id,
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$toast.open({
              message: "Something is wrong",
              type: "error",
              position: "top",
              queue: true
            });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getToken: function ({commit}, data) {
      let headers = {
        id: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).id
          : "",
        token: localStorage.getItem("user_info")
          ? JSON.parse(localStorage.getItem("user_info")).token
          : "",
      };
      return new Promise((resolve, reject) => {
        Axios({
          url: this.state.baseUrl + "/token/" + data.event_id,
          method: "GET",
          headers: headers,
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            console.log(error);
            this.$toast.open({
              message: "Something is wrong",
              type: "error",
              position: "top",
              queue: true
            });
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getStarted: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {"Content-Type": "application/json"};
        Axios({
          url: this.state.baseUrl + "/getstarted",
          data: data,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventStarted: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {"Content-Type": "application/json"};
        Axios({
          url: this.state.baseUrl + "/events/getstarted",
          data: data,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    reportIssue: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let verifyHeaders = {"Content-Type": "application/json"};
        Axios({
          url: this.state.baseUrl + "/reportIssue",
          data: data,
          headers: verifyHeaders,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    registerEvent: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/user/register/" + data.event_id,
          headers: headers,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getMembersData: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/members/" + data.channel_id,
          headers: headers,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              $.state.members = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventMembersData: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/members/" + data.channel_id,
          headers: headers,
          method: "GET",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              $.state.members = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeMessage: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        let message = {
          message: data.text,
        };
        Axios({
          url: this.state.baseUrl + "/video-call/message/" + data.channel_id,
          headers: headers,
          data: message,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventMessage: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        let message = {
          message: data.text,
        };
        Axios({
          url: this.state.baseUrl + "/events/message/" + data.channel_id,
          headers: headers,
          data: message,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getMessage: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url:
            this.state.baseUrl + "/video-call/get/message/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventMessage: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url:
            this.state.baseUrl + "/events/get/message/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },


    storeQna: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        let message = {
          message: data.text,
        };
        Axios({
          url: this.state.baseUrl + "/video-call/qna/" + data.channel_id,
          headers: headers,
          data: message,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventQna: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        let message = {
          message: data.text,
        };
        Axios({
          url: this.state.baseUrl + "/events/qna/" + data.channel_id,
          headers: headers,
          data: message,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getQna: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/get/qna/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventQna: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/get/qna/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeTableStructure: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        // hello
        let table_data = $.state.tables;
        Axios({
          url: this.state.baseUrl + "/table/" + data.channel_id,
          headers: headers,
          data: table_data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeTableStructureWithId: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        // hello
        let table_data = {
          table_id: data.table_id,
          chair_id: data.chair_id
        }
        Axios({
          url: this.state.baseUrl + "/table/id/" + data.channel_id,
          headers: headers,
          data: table_data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              // $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventTableStructureWithId: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        // hello
        let table_data = {
          table_id: data.table_id,
          chair_id: data.chair_id
        }
        Axios({
          url: this.state.baseUrl + "/events/table/id/" + data.channel_id,
          headers: headers,
          data: table_data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              // $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    LeaveTableStructureWithId: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        // hello
        let table_data = {
          table_id: data.table_id,
          chair_id: data.chair_id
        }
        Axios({
          url: this.state.baseUrl + "/table/id/leave/" + data.channel_id,
          headers: headers,
          data: table_data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              // $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    LeaveEventTableStructureWithId: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        // hello
        let table_data = {
          table_id: data.table_id,
          chair_id: data.chair_id
        }
        Axios({
          url: this.state.baseUrl + "/events/table/id/leave/" + data.channel_id,
          headers: headers,
          data: table_data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              // $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventTableStructure: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        // hello
        Axios({
          url: this.state.baseUrl + "/events/table/" + data.channel_id,
          headers: headers,
          data: $.state.tables,
          method: "POST",

        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
            console.log(error.message);
          });
      });
    },

    getTableStructure: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/table/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventTableStructure: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/table/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getTableStructureWithId: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/table/id/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventTableStructureWithId: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/table/id/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              $.state.tables = resp.data.data;
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeMeetingStates: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };

        let states = {
          is_networking: $.state.isNetworking,
          is_live: $.state.isLive,
          is_break: $.state.isBreak,
          is_expire: $.state.isExpire,
          is_end: $.state.isEnd,
        };
        Axios({
          url: this.state.baseUrl + "/video-call/status/" + data.channel_id,
          headers: headers,
          data: states,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventMeetingStates: function ({commit}, data) {
      const $ = this;
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/status/" + data.channel_id,
          headers: headers,
          data: {
            is_networking: $.state.isNetworking,
            is_live: $.state.isLive,
            is_break: $.state.isBreak,
            is_expire: $.state.isExpire,
            is_end: $.state.isEnd,
            recording_id: $.state.sid
          },
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getMeetingStates: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/status/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              this.state.isNetworking = resp.data.data["is_networking"];
              this.state.isLive = resp.data.data["is_live"];
              this.state.isBreak = resp.data.data["is_break"];
              this.state.isExpire = resp.data.data["is_expire"];
              this.state.isEnd = resp.data.data["is_end"];
              this.state.isSpeaker = resp.data.data["is_speaker"];
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventMeetingStates: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/status/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              this.state.isNetworking = resp.data.data["is_networking"];
              this.state.isLive = resp.data.data["is_live"];
              this.state.isBreak = resp.data.data["is_break"];
              this.state.isExpire = resp.data.data["is_expire"];
              this.state.isEnd = resp.data.data["is_end"];
              this.state.isSpeaker = resp.data.data["is_speaker"];
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    inviteSpeakers: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/speaker/" + data.channel_id,
          headers: headers,
          data: data.emails,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },
    submitFeedback: function ({commit}, data) {	
      return new Promise((resolve, reject) => {	
        let headers = {	
          "Content-Type": "application/json",	
          id: localStorage.getItem("user_info")	
            ? JSON.parse(localStorage.getItem("user_info")).id	
            : "",	
          token: localStorage.getItem("user_info")	
            ? JSON.parse(localStorage.getItem("user_info")).token	
            : "",	
        };	
        Axios({	
          url: this.state.baseUrl + "/events/feedback/" + data.event_id + "/" + data.session_id,	
          headers: headers,	
          data: {"rating": data.rating, "message": data.message },	
          method: "post",	
        })	
          .then((resp) => {	
            if (resp.data.status === "success") {	
              resolve(resp);	
            } else {	
              resolve(resp);	
            }	
          })	
          .catch((error) => {	
            commit("auth_error", error);	
            reject(error);	
          });	
      });	
    },
    inviteEventSpeakers: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/speaker/" + data.channel_id,
          headers: headers,
          data: data.emails,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getSpeakers: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/speaker/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventSpeakers: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/speaker/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeReaction: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };

        let reaction = {
          "type": data.type
        };
        Axios({
          url: this.state.baseUrl + "/video-call/reaction/" + data.channel_id,
          headers: headers,
          data: reaction,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventReaction: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };

        let reaction = {
          "type": data.type
        };
        Axios({
          url: this.state.baseUrl + "/events/reaction/" + data.channel_id,
          headers: headers,
          data: reaction,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getReaction: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/reaction/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventReaction: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/reaction/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getRecordingResourceId: function ({commit}, data) {
      console.log("recording acquire data: ", data);
      // if (data) {
      //   commit("rec_error", "No error, only testing");
      // }
      return new Promise((resolve, reject) => {
        // let auth = `${customer_id}:${customer_certificate}`;
        let headers = {
          "Content-Type": "application/json",
          // Authorization: `Basic ${btoa(auth)}`,
        };
        let payload = {
          "cname": data.cname,
          "uid": `${this.state.recordingUid}`,
          "clientRequest": {
            "resourceExpiredHour": 72,
          },
        };
        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/acquire`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          data: JSON.stringify(payload),
          method: "post",
        })
          .then((resp) => {
            if (resp.status === 200) {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    getEventRecordingResourceId: function ({commit}, data) {
      console.log("recording acquire data: ", data);
      // if (data) {
      //   commit("rec_error", "No error, only testing");
      // }
      return new Promise((resolve, reject) => {
        // let auth = `${customer_id}:${customer_certificate}`;
        let headers = {
          "Content-Type": "application/json",
          // Authorization: `Basic ${btoa(auth)}`,
        };
        let payload = {
          "cname": data.cname,
          "uid": `${this.state.recordingUid}`,
          "clientRequest": {
            "resourceExpiredHour": 72,
          },
        };
        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/acquire`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          data: JSON.stringify(payload),
          method: "post",
        })
          .then((resp) => {
            if (resp.status === 200) {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    startRecording: function ({commit}, data) {
      console.log("recording acquire start data: ", data);
      // if (data) {
      //   commit("rec_error", "No error, only testing");
      // }
      let dirName = data.cname.replace(/[^A-Z0-9]/ig, "");
      console.log('dir name: ', dirName);
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
        };
        let payload = {
          "cname": data.cname,
          "uid": `${this.state.recordingUid}`,
          "clientRequest": {
            "token": this.state.recordingToken,
            "recordingConfig": {
              "maxIdleTime": 120,
              "streamTypes": 2,
              "channelType": 1,
              "transcodingConfig": {
                "height": 1080,
                "width": 1920,
                "fps": 15,
                "bitrate": 2080,
                "mixedVideoLayout": 1,
                "backgroundColor": "#000000",
              },
              "subscribeVideoUids": ["#allstream#"],
              "subscribeAudioUids": ["#allstream#"],
              "subscribeUidGroup": 0
            },
            "recordingFileConfig": {
              "avFileType": ["hls"],
            },
            "storageConfig": {
              "vendor": this.state.VENDOR,
              "region": this.state.REGION,
              "bucket": this.state.BUCKET,
              "accessKey": this.state.ACCESS_KEY,
              "secretKey": this.state.SECRET_KEY,
              "fileNamePrefix": [`${dirName}`],
            },
          },
        };
        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/resourceid/${this.state.resourceId}/mode/mix/start`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          data: JSON.stringify(payload),
          method: "post",
        })
          .then((resp) => {
            console.log('start rec: ', resp);
            if (resp.status === 200) {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    startEventRecording: function ({commit}, data) {
      console.log("recording acquire start data: ", data);
      // if (data) {
      //   commit("rec_error", "No error, only testing");
      // }
      let dirName = data.cname.replace(/[^A-Z0-9]/ig, "");
      console.log('dir name: ', dirName);
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
        };
        let payload = {
          "cname": data.cname,
          "uid": `${this.state.recordingUid}`,
          "clientRequest": {
            "token": this.state.recordingToken,
            "recordingConfig": {
              "maxIdleTime": 120,
              "streamTypes": 2,
              "channelType": 1,
              "transcodingConfig": {
                "height": 1080,
                "width": 1920,
                "fps": 15,
                "bitrate": 2080,
                "mixedVideoLayout": 1,
                "backgroundColor": "#000000",
              },
              "subscribeVideoUids": ["#allstream#"],
              "subscribeAudioUids": ["#allstream#"],
              "subscribeUidGroup": 0
            },
            "recordingFileConfig": {
              "avFileType": ["hls"],
            },
            "storageConfig": {
              "vendor": this.state.VENDOR,
              "region": this.state.REGION,
              "bucket": this.state.BUCKET,
              "accessKey": this.state.ACCESS_KEY,
              "secretKey": this.state.SECRET_KEY,
              "fileNamePrefix": [`${dirName}`],
            },
          },
        };
        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/resourceid/${this.state.resourceId}/mode/mix/start`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          data: JSON.stringify(payload),
          method: "post",
        })
          .then((resp) => {
            console.log('start rec: ', resp);
            if (resp.status === 200) {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    updateLayoutRecording: function ({commit}, data) {
      console.log("recording acquire query data: ", data);
      return new Promise((resolve, reject) => {
        // let auth = `${customer_id}:${customer_certificate}`;
        let headers = {
          "Content-Type": "application/json",
          // Authorization: `Basic ${btoa(auth)}`,
        };
        console.log('update layout: ', data)
        let payload;
        if(data.recordingId === 10000320) {
          console.log('called update', data.recordingId)
          payload = {
            "cname": data.cname,
            "uid": `${this.state.recordingUid}`,
            "clientRequest": {
              "mixedVideoLayout": 2,
              "maxResolutionUid": "10000320",
              "backgroundColor": "#000000",
            },
          };
        } else if(data.recordingId === 666) {
          payload = {
            "cname": data.cname,
            "uid": `${this.state.recordingUid}`,
            "clientRequest": {
              "mixedVideoLayout": 2,
              "maxResolutionUid": "666",
              "backgroundColor": "#000000",
            },
          };
        } else {
          commit("updateLayout");
          console.log("layout updated: ", this.state.result);
          payload = {
            "cname": data.cname,
            "uid": `${this.state.recordingUid}`,
            "clientRequest": {
              "mixedVideoLayout": 3,
              "backgroundColor": "#000000",
              "layoutConfig": this.state.result
            },
          };
        }


        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/resourceid/${this.state.resourceId}/sid/${this.state.sid}/mode/mix/updateLayout`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          data: JSON.stringify(payload),
          method: "post",
        })
          .then((resp) => {
            if (resp.status === 200) {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    updateEventLayoutRecording: function ({commit}, data) {
      console.log("recording acquire query data: ", data);
      return new Promise((resolve, reject) => {
        // let auth = `${customer_id}:${customer_certificate}`;
        let headers = {
          "Content-Type": "application/json",
          // Authorization: `Basic ${btoa(auth)}`,
        };
        console.log('update layout: ', data)
        let payload;
        if(data.recordingId === 10000320) {
          console.log('called update', data.recordingId)
          payload = {
            "cname": data.cname,
            "uid": `${this.state.recordingUid}`,
            "clientRequest": {
              "mixedVideoLayout": 2,
              "maxResolutionUid": "10000320",
              "backgroundColor": "#000000",
            },
          };
        } else if(data.recordingId === 666) {
          payload = {
            "cname": data.cname,
            "uid": `${this.state.recordingUid}`,
            "clientRequest": {
              "mixedVideoLayout": 2,
              "maxResolutionUid": "666",
              "backgroundColor": "#000000",
            },
          };
        } else {
          commit("updateLayout");
          console.log("layout updated: ", this.state.result);
          payload = {
            "cname": data.cname,
            "uid": `${this.state.recordingUid}`,
            "clientRequest": {
              "mixedVideoLayout": 3,
              "backgroundColor": "#000000",
              "layoutConfig": this.state.result
            },
          };
        }


        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/resourceid/${this.state.resourceId}/sid/${this.state.sid}/mode/mix/updateLayout`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          data: JSON.stringify(payload),
          method: "post",
        })
          .then((resp) => {
            if (resp.status === 200) {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    queryRecording: function ({commit}, data) {
      console.log("recording acquire query data: ", data);
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
        };
        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/resourceid/${this.state.resourceId}/sid/${this.state.sid}/mode/mix/query`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          method: "get",
        })
          .then((resp) => {
            if (resp.status === 200) {
              console.log('query rec: ', resp)
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    queryEventRecording: function ({commit}, data) {
      console.log("recording acquire query data: ", data);
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
        };
        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/resourceid/${this.state.resourceId}/sid/${this.state.sid}/mode/mix/query`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          method: "get",
        })
          .then((resp) => {
            if (resp.status === 200) {
              console.log('query rec: ', resp)
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    stopRecording: function ({commit}, data) {
      console.log("recording acquire data: ", data);
      return new Promise((resolve, reject) => {
        // let auth = `${customer_id}:${customer_certificate}`;
        let headers = {
          "Content-Type": "application/json",
          // Authorization: `Basic ${btoa(auth)}`,
        };
        let payload = {
          "cname": data.cname,
          "uid": `${this.state.recordingUid}`,
          "clientRequest": {},
        };
        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/resourceid/${this.state.resourceId}/sid/${this.state.sid}/mode/mix/stop`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          data: JSON.stringify(payload),
          method: "post",
        })
          .then((resp) => {
            if (resp.status === 200) {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    stopEventRecording: function ({commit}, data) {
      console.log("recording acquire data: ", data);
      return new Promise((resolve, reject) => {
        // let auth = `${customer_id}:${customer_certificate}`;
        let headers = {
          "Content-Type": "application/json",
          // Authorization: `Basic ${btoa(auth)}`,
        };
        let payload = {
          "cname": data.cname,
          "uid": `${this.state.recordingUid}`,
          "clientRequest": {},
        };
        Axios({
          url: `${this.state.baseRecordingUrl}/v1/apps/${data.appId}/cloud_recording/resourceid/${this.state.resourceId}/sid/${this.state.sid}/mode/mix/stop`,
          headers: headers,
          auth: {
            username: this.state.customer_id,
            password: this.state.customer_certificate,
          },
          data: JSON.stringify(payload),
          method: "post",
        })
          .then((resp) => {
            if (resp.status === 200) {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("rec_error", error);
            reject(error);
          });
      });
    },

    storePoll: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/poll/create/" + data.channel_id,
          headers: headers,
          data: data.poll,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventPoll: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/poll/create/" + data.channel_id,
          headers: headers,
          data: data.poll,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getPolls: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/poll/get/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getEventPolls: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/poll/get/" + data.channel_id,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeAnswer: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/video-call/poll/select/" + data.channel_id,
          headers: headers,
          data: data.answer,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    storeEventAnswer: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/poll/select/" + data.channel_id,
          headers: headers,
          data: data.answer,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    createOrganization: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/organization",
          headers: headers,
          data: data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    updateOrganization: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/organization/update/" + data.id,
          headers: headers,
          data: data.orgDetails,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    deleteOrganization: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/organization/delete/" + data,
          headers: headers,
          data: {},
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getOrganization: function ({commit}) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/organization",
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    getOrgDetails: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/organization/" + data,
          headers: headers,
          method: "get",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },

    deleteEvent: function ({commit}, data) {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).id
            : "",
          token: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info")).token
            : "",
        };
        Axios({
          url: this.state.baseUrl + "/events/delete/hard/" + data,
          headers: headers,
          data: data,
          method: "post",
        })
          .then((resp) => {
            if (resp.data.status === "success") {
              resolve(resp);
            } else {
              resolve(resp);
            }
          })
          .catch((error) => {
            commit("auth_error", error);
            reject(error);
          });
      });
    },
  },
  modules: {},
});
